// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ke+lE","title":"styles_title__+p6CC","button":"styles_button__rfWrC","icon":"styles_icon__I3D8R","windows":"styles_windows__-ARGj"};